import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api/api";



// Centralisation des routes API
const API_ROUTES = {
    ADD_PRODUCT: `/api/product_add`,
    Get_SUBSCRIPTIONS_RQUESTS: `/api/admin/subscriptions/requests`,
    Get_SUBSCRIPTIONS_ACTIVE: `/api/admin/subscriptions/active`,
    Get_SUBSCRIPTIONS_EXPIRED : `/api/admin/subscriptions/expired`,
    Get_SUBSCRIPTIONS_REJECTED: `/api/admin/subscriptions/rejected`

};

// Fonction utilitaire pour la gestion des messages d'erreur
const getErrorMessage = (error) => error.response?.data.message || error.message;

// Action for adding a product
export const productAdd = createAsyncThunk(
    "product/productAdd",
    async (product, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.post(API_ROUTES.ADD_PRODUCT, product, { withCredentials: true });
            //console.log("API Response:", data); // Log the API response
            return fulfillWithValue(data);
        } catch (error) {
           // console.error("Error adding product", error);
            //return rejectWithValue(error.response?.data.message || error.message);
            return rejectWithValue(getErrorMessage(error));
        }
    }
);


// Demandes en attente
export const getSubscriptionRequests = createAsyncThunk(
  "subscription/getRequests",
  async (_, { rejectWithValue, fulfillWithValue}) => {
    try {
      const { data } = await api.get(API_ROUTES.Get_SUBSCRIPTIONS_RQUESTS, { withCredentials: true });
     // console.log("API Response:", data); // Log the API response
      return fulfillWithValue(data);
    } catch (err) {
     // return rejectWithValue(err.response.data.message);
     return rejectWithValue(getErrorMessage(err));
    }
  }
);

// Abonnements actifs
export const getActiveSubscriptions = createAsyncThunk(
  "subscription/getActive",
  async (_, { rejectWithValue,fulfillWithValue }) => {
    try {
      const { data } = await api.get(API_ROUTES.Get_SUBSCRIPTIONS_ACTIVE, { withCredentials: true });
      //console.log("API Response:", data); // Log the API response
      //return data;
      return fulfillWithValue(data);
    } catch (err) {
     // return rejectWithValue(err.response.data.message);
     return rejectWithValue(getErrorMessage(err));
    }
  }
);

// Abonnements expirés
export const getExpiredSubscriptions = createAsyncThunk(
  "subscription/getExpired",
  async (_, { rejectWithValue, fulfillWithValue}) => {
    try {
      const { data } = await api.get(API_ROUTES.Get_SUBSCRIPTIONS_EXPIRED, { withCredentials: true });
      //return data;
      return fulfillWithValue(data);
    } catch (err) {
      //return rejectWithValue(err.response.data.message);
      return rejectWithValue(getErrorMessage(err));
    }
  }
);

// Abonnements rejetés
export const getRejectedSubscriptions = createAsyncThunk(
  "subscription/getRejected",
  async (_, { rejectWithValue, fulfillWithValue}) => {
    try {
      const { data } = await api.get(API_ROUTES.Get_SUBSCRIPTIONS_REJECTED, { withCredentials: true });
      //return data;
      return fulfillWithValue(data);
    } catch (err) {
      //return rejectWithValue(err.response.data.message);
      return rejectWithValue(getErrorMessage(err));
    }
  }
);


// Main reducer
export const subscriptionReducer = createSlice({
    name: 'subscription',
    initialState: {
        success: '',
        error: '',
        loading: false,
        subscriptions: [],
        subscription: {},
        totalSubscriptions: 0,
        requests: [],
        active : [],
        expired : [],
        rejected: []
         
    },
    
    reducers: {
        messageClear: (state) => {
            state.error = "";
            state.success = "";
        },
    },
    
    extraReducers: (builder) => {
    builder
      // DEMANDES
      .addCase(getSubscriptionRequests.pending, (state) => {
        state.loading = true;
      })
      .addCase(getSubscriptionRequests.fulfilled, (state, action) => {
        state.loading = false;
        state.requests = action.payload;
      })
      .addCase(getSubscriptionRequests.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ACTIVE
      .addCase(getActiveSubscriptions.pending, (state) => {
        state.loading = true;
      })
      .addCase(getActiveSubscriptions.fulfilled, (state, action) => {
        state.loading = false;
        state.active = action.payload;
      })
      .addCase(getActiveSubscriptions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // EXPIRED
      .addCase(getExpiredSubscriptions.pending, (state) => {
        state.loading = true;
      })
      .addCase(getExpiredSubscriptions.fulfilled, (state, action) => {
        state.loading = false;
        state.expired = action.payload;
      })
      .addCase(getExpiredSubscriptions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // REJECTED
      .addCase(getRejectedSubscriptions.pending, (state) => {
        state.loading = true;
      })
      .addCase(getRejectedSubscriptions.fulfilled, (state, action) => {
        state.loading = false;
        state.rejected = action.payload;
      })
      .addCase(getRejectedSubscriptions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { messageClear } = subscriptionReducer.actions;
export default subscriptionReducer.reducer;


